var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[(_vm.isMobile)?_c('v-col',{attrs:{"cols":12}},[_c('v-alert',{attrs:{"type":"warning"}},[_vm._v(" PDF Generator is Only Available on Desktop Browsers ")])],1):_c('v-col',{attrs:{"cols":12}},[_c('iframe',{attrs:{"src":_vm.pdf,"width":"100%","height":"900"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }